function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import { CrossIcon, VoiceIcon } from "@t8891/icon";
import { withNativeProps } from "../../utils/with-native-props";
import cx from "classnames";
var classPrefix = "tc-marquee";
var Marquee = function Marquee(props) {
  var children = props.children,
    style = props.style,
    _props$leftIcon = props.leftIcon,
    leftIcon = _props$leftIcon === void 0 ? false : _props$leftIcon,
    _props$rightIcon = props.rightIcon,
    rightIcon = _props$rightIcon === void 0 ? false : _props$rightIcon,
    _props$fill = props.fill,
    fill = _props$fill === void 0 ? "#3264FF" : _props$fill,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? "vertical" : _props$direction,
    itemStyle = props.itemStyle;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var length = Array.isArray(children) ? children.length : 0;
  var baseProps = {
    className: cx(classPrefix, "".concat(classPrefix, "-").concat(direction)),
    style: Object.assign({
      "--count": length
    }, style)
  };
  if (!visible) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-container")
  }, leftIcon && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-left-icon")
  }, _typeof(leftIcon) === "object" ? leftIcon : /*#__PURE__*/React.createElement(VoiceIcon, {
    size: 40,
    fill: fill
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-landscape-width")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-list")
  }, Array.isArray(children) && children.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classPrefix, "-item"),
      style: itemStyle,
      key: index
    }, item);
  }), Array.isArray(children) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-item"),
    style: itemStyle
  }, children[0]))), rightIcon && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-right-icon")
  }, _typeof(rightIcon) === "object" ? rightIcon : /*#__PURE__*/React.createElement(CrossIcon, {
    size: 40,
    fill: fill,
    onClick: function onClick() {
      return setVisible(false);
    }
  })))));
};
Marquee.defaultProps = {
  leftIcon: false,
  rightIcon: false
};
export default Marquee;